module.exports = __webpack_public_path__ + "img/full1-min.75b2ef42.png";